module.exports = __webpack_public_path__ + "img/sun_icon.f24e96e4.svg";